import { render, staticRenderFns } from "./review-product-add.vue?vue&type=template&id=50dd7726&scoped=true&"
import script from "./review-product-add.vue?vue&type=script&lang=js&"
export * from "./review-product-add.vue?vue&type=script&lang=js&"
import style0 from "./review-product-add.vue?vue&type=style&index=0&id=50dd7726&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50dd7726",
  null
  
)

export default component.exports